import { CourseLanguageData } from "../../models/courseData";

/**
 * Represents the state for course languages in the Redux store.
 */
export interface CourseLanguageState {
  courseLanguages: CourseLanguageData[];
  isLoading: boolean;
  courseLanguagesLoaded: boolean;
  error: boolean;
}

/**
 * Action type dispatched when course language request starts.
 */
export const COURSE_LANGUAGES_REQUEST = "COURSE_LANGUAGES_REQUEST";

/**
 * Action type dispatched when course languages are successfully fetched.
 */
export const COURSE_LANGUAGES_SUCCESS = "COURSE_LANGUAGES_SUCCESS";

/**
 * Action type dispatched when there is an error fetching course languages.
 */
export const COURSE_LANGUAGES_FAILURE = "COURSE_LANGUAGES_FAILURE";

/**
 * Action for initiating a course language fetch request.
 */
export interface CourseLanguagesRequestAction {
  type: typeof COURSE_LANGUAGES_REQUEST;
}

/**
 * Action for handling a failed course language fetch request.
 */
export interface CourseLanguagesFailureAction {
  type: typeof COURSE_LANGUAGES_FAILURE;
}

/**
 * Action for handling a successful course language fetch.
 */
export interface CourseLanguagesSuccessAction {
  type: typeof COURSE_LANGUAGES_SUCCESS;
  data: CourseLanguageData[];
}

/**
 * Union type for all possible course language action types.
 */
export type CourseLanguageActionTypes =
  | CourseLanguagesRequestAction
  | CourseLanguagesSuccessAction
  | CourseLanguagesFailureAction;
